import { Asset } from 'contentful'
import { ResponsiveImage } from '~/components/ResponsiveImage'
import { TypeBlogImage } from '~/types/contentful'

type BlogImageProps = {
  blogAsset: TypeBlogImage<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const BlogImage = ({ blogAsset }: BlogImageProps) => {
  const { fields } = blogAsset
  const { image, url } = fields

  if (!image) return <></>

  return (
    <a href={url} className="flex flex-col m-12 max-md:m-7 max-xl:m-10">
      <ResponsiveImage asset={(image as Asset<'WITHOUT_UNRESOLVABLE_LINKS', string>).fields} />
    </a>
  )
}
